import axios from "axios";
import { pbxAuthHeader } from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_PBX_API;

class TicketService {
  // TICKET TITLE RELATED APIs

  // Get ticket title list
  async getTicketTitleList() {
    return await axios
      .get(API_URL + "support/ticket-title", {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get ticket title details
  async getTicketTitleDetail(ticket_title_id) {
    return await axios
      .get(API_URL + "support/ticket-title/" + ticket_title_id, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Add ticket title detail
  async createTicketTitle(data) {
    const response = await axios.post(API_URL + "support/ticket-title", data, {
      headers: pbxAuthHeader(),
    });
    return response.data;
  }

  // Update ticket title detail
  async updateTicketTitleDetail(ticket_title_id, data) {
    const response = await axios.patch(
      API_URL + "support/ticket-title/" + ticket_title_id,
      data,
      {
        headers: pbxAuthHeader(),
      }
    );
    return response.data;
  }

  // Delete ticket title
  async deleteTicketTitle(ticket_title_id) {
    const response = await axios.delete(
      API_URL + "support/ticket-title/" + ticket_title_id,
      {
        headers: pbxAuthHeader(),
      }
    );
    return response.data;
  }

  // TICKET  RELATED APIs

  // Get ticket list
  async getTicketList(filter) {
    return await axios
      .get(API_URL + "support/ticket" + filter, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Add ticket  details
  async createTicket(data, domain_id) {
    return await axios
      .post(API_URL + "support/ticket", data, {
        headers: pbxAuthHeader(domain_id),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get ticket  details
  async getTicketDetail(ticket_id, domain_id) {
    return await axios
      .get(API_URL + "support/ticket/" + ticket_id, {
        headers: pbxAuthHeader(domain_id),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Update ticket status
  async updateTicketStatus(ticket_id, data) {
    const response = await axios.patch(
      API_URL + "support/ticket/" + ticket_id,
      data,
      {
        headers: pbxAuthHeader(),
      }
    );
    return response.data;
  }

  // Update ticket detail
  async updateTicketDetail(ticket_id, data, domain_id) {
    const response = await axios.put(
      API_URL + "support/ticket/" + ticket_id,
      data,
      {
        headers: pbxAuthHeader(domain_id),
      }
    );
    return response.data;
  }

  // Update ticket detail
  async updateTicket(ticket_id, data, domain_id) {
    const response = await axios.patch(
      API_URL + "support/ticket/" + ticket_id,
      data,
      {
        headers: pbxAuthHeader(domain_id),
      }
    );
    return response.data;
  }

  // Get ticket filter based on agent wise
  async getTicketByAgent() {
    return await axios
      .get(API_URL + "support/ticket-filter/agent-wise-ticket", {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get ticket count
  async getTicketCount(filter = "") {
    return await axios
      .get(API_URL + "support/ticket-filter/ticket-count" + filter, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new TicketService();
